const getters = {
  selectedNotesToApuration: (state) => state.notesFromDB,
  selectedItensFromSPED: (state) => state.itensFromSPED,
  selectedItensFromXML: (state) => state.itensFromXML,
  getNoteById:
    ({ notesFromDB }) =>
    (idNfe) => {
      if (!idNfe) return;
      return notesFromDB.tBody.filter((item) => item.idNfe === idNfe);
    },
  getItensByIdRegC100: (state) => (idRegC100) => {
    return state.itensFromSPED.filter((item) => item.idNf === idRegC100);
  },
  getItensByIdNfe: (state) => (idNfe) => {
    if (!idNfe) return;
    return state.itensFromXML.filter((item) => item.idNf === idNfe);
  },
  getPayLoadToReference: (state) => {
    return state.payLoadToReference;
  },
  getReferencedItems: (_, getters) => (idNfe) => {
    const [{ credOutorgado, cpfCnpj }] = getters.getNoteById(idNfe);
    const [{ itens: { tBody } = {} }] = getters.getItensByIdNfe(idNfe);
    const hasReferenced = tBody
      .filter((item) => item.referenced)
      .map((item) => ({ ...item, credOutorgado, cpfCnpj }));
    return hasReferenced;
  },
  getTotalApuredByNote:
    ({ itensFromXML }) =>
    (idNfe) => {
      const [
        {
          itens: { tBody },
        },
      ] = itensFromXML.filter((item) => item.idNf === idNfe);
      if (!tBody) return;
      const itemsCells = tBody
        .filter((item) => item.referenced)
        .flatMap((item) => item.cells);

      return itemsCells.reduce(
        (acc, { name, value }) => {
          if (!["vlStIcms", "vlPobIcms"].includes(name)) return acc;
          if (name === "vlStIcms") acc.vlIcmsDar += value;
          if (name === "vlPobIcms") acc.vlPobreza += value;
          return acc;
        },
        { vlIcmsDar: 0, vlPobreza: 0 },
      );
    },
};

export default getters;
